import { Button, ButtonProps, styled } from '@quillbot/design-system';
import Link from 'next/link';

const StyledButton = styled(Button)`
  && {
    font-weight: 700;
    margin-right: 10px;
    // width: 150px;
    // width: 155px;
    text-align: center;
    padding: 6px;
    margin: 0;
    border-radius: 20px;
  }
`;

interface IProps extends ButtonProps {
  bgColor?: 'primary' | 'secondary';
}

const UseCoWriterButton = (props: IProps) => (
  <Link href="/co-writer">
    <StyledButton
      className="no-box-shadow"
      variant="contained"
      color={props.bgColor ? props.bgColor : 'primary'}
      style={{ paddingLeft: '13.5px', paddingRight: '13.5px' }}
    >
      <img
        src="/images/theme/commonImages/co-writer-icon-new.svg"
        alt="co-writer icon"
        style={{
          width: 18,
          height: 20,
          marginRight: 8,
        }}
      />
      Try the Co-Writer
    </StyledButton>
  </Link>
);

export default UseCoWriterButton;
